export default function handleKeyPress(event) {
    if (event.key === 'Enter') {
        event.target.blur();
    }
}
